module.exports = __webpack_public_path__ + "static/logo-746bec51c58599287c7a38af0f4d0551.png";